import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { PaymentData } from 'src/app/modules/shared/models/payment.model';

@Component({
  selector: 'payment-cta-container',
  templateUrl: './payment-cta-container.component.html',
  styleUrls: ['./payment-cta-container.component.scss'],
})
export class PaymentCtaContainerComponent {
  @Input() paymentData: PaymentData;

  constructor(private router: Router) {}

  goToCheckout() {
    if (!this.paymentData.isValid) {
      this.scrollToTop();
      return;
    }

    this.router.navigate(['/checkout']);
  }

  private scrollToTop() {
    const viewport = document.querySelector('cdk-virtual-scroll-viewport');
    if (viewport) {
      viewport.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
      setTimeout(() => {
        this.UnSafeMarkEmailAsTouched();
      }, 200);
    }
  }

  private UnSafeMarkEmailAsTouched() {
    const emailButton = document.querySelector('#email-input');
    if (emailButton) {
      emailButton.classList.remove('ng-untouched');
      emailButton.classList.add('ng-touched');
    }
  }
}
